import '../css/Site.css';
import logo from '../img/logo-light.png';
import { Link } from "react-router-dom";
import { NAV_LINKS } from './Comp_Header.js';

function Comp_Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="pb-footer">
      <div className="pb-footer-primary">
        <Link to="/">
          <img className="pb-logo" src={logo} alt="Pixelbear Digital Studio" />
        </Link>
        <ul className="pb-nav">
          {NAV_LINKS.map(({ to, label }) => (
            <li key={to}><Link to={to}>{label}</Link></li>
          ))}
        </ul>
      </div>

      <div className="pb-footer-rule" />

      <div className="pb-footer-meta">
        <p className="pb-footer-small">Pixelbear.Studio</p>
        <p className="pb-footer-tagline">Full-service digital studio for product, development, and visual craft.</p>
        <div className="pb-footer-right">
          <button type="button" className="pb-to-top" onClick={toTop}>Back to top ↑</button>
        </div>
      </div>
    </footer>
  );
}

export default Comp_Footer;
